import { IOrder, IOrderPayments } from '@hooks/useCurrentOrder/models';

export default function findValidCharge(
  order?: IOrder,
): IOrderPayments | undefined {
  return order?.order.payments.find(
    (payment: IOrderPayments) => payment.charges && payment.charges.length > 0,
  );
}
